var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-item"},[_c('div',{on:{"click":_vm.click_handle}},[_c('van-image',{attrs:{"src":_vm.item.icon}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.item.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }